// document.addEventListener("DOMContentLoaded", function () {
//     const section1 = document.querySelector(".dropdown_section");
//     const section2 = document.querySelector(".lilliputimage");
//     const section3 = document.querySelector(".nightwear-promo-sections");

//     if (section1 && section2) {
//       // Create wrapper
//       const wrapper = document.createElement("div");
//       wrapper.className = "background-wrapper";

//       // Insert wrapper before first section
//       section1.parentNode.insertBefore(wrapper, section1);

//       // Move both sections inside wrapper
//       wrapper.appendChild(section1);
//       wrapper.appendChild(section2);
//         wrapper.appendChild(section3);
      
//     }
// });

document.addEventListener("DOMContentLoaded", function () {
    const section1 = document.querySelector(".dropdown_section");
    const section2 = document.querySelector(".lilliputimage");
    // const section3 = document.querySelector(".nightwear-promo-sections");
    const section4 = document.querySelector(".best-seller-section");
    

    if (section1 && section2) {
      // Create wrapper
      const wrapper = document.createElement("div");
      wrapper.className = "background-wrapper";

      // Insert wrapper before first section
      section1.parentNode.insertBefore(wrapper, section1);

      // Move both sections inside wrapper
      wrapper.appendChild(section1);
      wrapper.appendChild(section2);
      wrapper.appendChild(section4);
        // wrapper.appendChild(section3);
      
    }
});